<router-outlet></router-outlet>

<!-- Modal global de upload de foto (usuário, cliente, bandeira) -->
<app-photo-upload-modal></app-photo-upload-modal>

<!-- Modal global com a lista de erros da API ("Ver mais" do toast de erro) -->
<app-api-error-modal></app-api-error-modal>
